const initialState = {
  isLoading: false,
  error: '',
  data: null,
};

export const getBrowseQuestionsRequest = (state) => ({
  ...state,
  isLoading: true,
  error: '',
});

export const getBrowseQuestionsSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: '',
    data: payload,
  };
};

export const getBrowseQuestionsFailure = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: payload,
  };
};

export default initialState;
